export const TEMPLATE_DEPLOYMENT_MESSAGE =
  "This stack can't be modified because it was created from a template deployment.";
